import React from 'react'

const NetworkIcon = (props) => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    	 viewBox="0 0 512 512" {...props} >
    <g>
    	<g>
    		<path d="M446.5,342.471h-8.07c6.586-8.585,10.514-19.312,10.514-30.943v-14.112c0-28.091-22.854-50.944-50.943-50.944
    			s-50.943,22.854-50.943,50.944v14.112c0,11.632,3.927,22.358,10.514,30.943h-8.07c-2.854,0-5.661,0.204-8.42,0.56l-45.037-45.038
    			c-8.463-8.462-18.962-13.669-29.934-15.644c0.004-0.118,0.018-0.234,0.018-0.353v-18.252l23.846-23.846
    			c2.278,0.138,5.24,0.257,8.723,0.257c18.576,0,51.849-3.363,73.863-24.971c29.578-29.027,25.634-79.604,24.823-87.426
    			c-0.138-2.362-1.109-4.685-2.914-6.489c-1.778-1.779-4.061-2.747-6.389-2.904c-4.498-0.392-55.643-4.085-85.849,25.544
    			c-25.887,25.405-26.861,66.752-26.262,81.708l-9.842,9.842v-71.298c11.28-9.989,42.265-40.872,42.621-78.984
    			c0.405-43.137-39.812-77.512-46.129-82.643c-1.768-1.575-4.1-2.532-6.654-2.532c-2.519,0-4.819,0.932-6.577,2.469
    			c-3.614,3.037-44,37.96-44.425,82.016c-0.359,38.332,29.938,69.575,41.164,79.801v71.425l-12.209-12.209
    			c0.581-14.766-0.431-55.191-25.783-80.073c-29.41-28.849-78.946-25.517-84.081-25.084c-2.271,0.122-4.51,1.015-6.295,2.685
    			c-1.926,1.802-2.982,4.191-3.145,6.638c-0.77,7.333-4.79,57.248,24.36,85.856c21.613,21.213,54.265,24.513,72.486,24.513
    			c3.366,0,6.238-0.113,8.459-0.246L246.127,264v17.999c0,0.105,0.013,0.206,0.016,0.31c-11.063,1.94-21.658,7.159-30.186,15.687
    			l-45.037,45.038c-2.759-0.356-5.565-0.56-8.42-0.56h-8.07c6.586-8.585,10.514-19.312,10.514-30.943v-14.112
    			c0-28.091-22.854-50.944-50.943-50.944s-50.943,22.854-50.943,50.944v14.112c0,11.632,3.927,22.358,10.514,30.943H65.5
    			c-36.117,0-65.5,29.383-65.5,65.5v94.024c0,5.522,4.478,10,10,10h208c5.522,0,10-4.478,10-10v-94.024
    			c0-25.319-14.449-47.312-35.526-58.209l37.625-37.626c14.282-14.281,37.521-14.28,51.801,0l37.625,37.626
    			C298.449,360.659,284,382.652,284,407.971v94.024c0,5.522,4.478,10,10,10h208c5.522,0,10-4.478,10-10v-94.024
    			C512,371.853,482.617,342.471,446.5,342.471z M316.238,158.184c17.954-17.611,47.291-20.092,61.717-20.156
    			c0.339,14.795-1.392,45.204-19.405,62.882c-13.241,12.995-32.975,17.403-48.304,18.715l17.192-17.192
    			c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.904-10.236-3.904-14.143,0l-16.653,16.653
    			C298.333,189.942,303.196,170.982,316.238,158.184z M200.872,190.456c-3.906-3.904-10.236-3.904-14.143,0
    			c-3.905,3.905-3.905,10.237,0,14.143l12.924,12.924c-14.879-1.318-33.829-5.672-46.669-18.274
    			c-17.506-17.179-19.257-46.701-18.944-61.228c14.126,0.079,42.614,2.544,60.087,19.683c12.557,12.323,17.346,30.507,19.059,45.066
    			L200.872,190.456z M83.057,297.415c0-17.063,13.881-30.944,30.943-30.944s30.943,13.882,30.943,30.944v14.112
    			c0,17.063-13.881,30.943-30.943,30.943s-30.943-13.88-30.943-30.943V297.415z M208,407.971v84.024h-28v-75.472
    			c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v75.472H68v-75.472c0-5.522-4.478-10-10-10s-10,4.478-10,10v75.472H20v-84.024
    			c0-25.089,20.411-45.5,45.5-45.5h97C187.589,362.471,208,382.882,208,407.971z M256.127,91.995c-5.522,0-10,4.478-10,10v33.245
    			c-10.164-12.442-21.351-30.681-21.164-50.564c0.257-26.73,20.596-50.567,31.173-61.169C267.282,34.092,289,58.183,288.748,84.988
    			c-0.186,19.93-12.037,38.21-22.621,50.595v-33.588C266.127,96.473,261.649,91.995,256.127,91.995z M367.057,297.415
    			c0-17.063,13.881-30.944,30.943-30.944c17.062,0,30.943,13.882,30.943,30.944v14.112c0,17.063-13.881,30.943-30.943,30.943
    			c-17.062,0-30.943-13.88-30.943-30.943V297.415z M492,491.995h-28v-37c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v37h-92
    			v-75.472c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v75.472h-28v-84.024c0-25.089,20.411-45.5,45.5-45.5h97
    			c25.089,0,45.5,20.411,45.5,45.5V491.995z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M461.069,409.455c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21,1.069-7.07,2.93c-1.86,1.859-2.93,4.439-2.93,7.07
    			c0,2.63,1.069,5.21,2.93,7.069c1.86,1.86,4.44,2.931,7.07,2.931s5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069
    			C464,413.894,462.93,411.314,461.069,409.455z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<polygon points="138.975,213.522 138.975,213.523 138.976,213.523 		"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M73.057,17.995c-5.522,0-10,4.478-10,10v12.43c0,5.522,4.477,10,10,10c5.522,0,10-4.478,10-10v-12.43
    			C83.057,22.473,78.579,17.995,73.057,17.995z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M73.057,77.565c-5.522,0-10,4.478-10,10v12.43c0,5.523,4.477,10,10,10c5.522,0,10-4.478,10-10v-12.43
    			C83.057,82.043,78.579,77.565,73.057,77.565z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M109.057,53.995H96.626c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h12.431c5.522,0,10-4.478,10-10
    			C119.057,58.473,114.579,53.995,109.057,53.995z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M49.487,53.995h-12.43c-5.522,0-10,4.478-10,10c0,5.522,4.477,10,10,10h12.43c5.522,0,10-4.478,10-10
    			C59.487,58.473,55.009,53.995,49.487,53.995z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M466,143.722c-5.522,0-10,4.478-10,10v12.43c0,5.523,4.478,10,10,10c5.522,0,10-4.478,10-10v-12.43
    			C476,148.2,471.522,143.722,466,143.722z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M466,203.292c-5.522,0-10,4.478-10,10v12.431c0,5.522,4.478,10,10,10c5.522,0,10-4.478,10-10v-12.431
    			C476,207.77,471.522,203.292,466,203.292z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M502,179.723h-12.43c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10H502c5.522,0,10-4.478,10-10
    			C512,184.201,507.522,179.723,502,179.723z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M442.43,179.723H430c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h12.43c5.522,0,10-4.478,10-10
    			C452.43,184.201,447.952,179.723,442.43,179.723z"/>
    	</g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>
  )
}

export default NetworkIcon
